import {
  BONUS_FETCH_FAILURE,
  BONUS_FETCH_SUCCESS,
  HIDE_BONUS_MODAL,
  SHOW_BONUS_ERROR,
  SHOW_BONUS_MODAL,
} from "@shared/constants";

import { initialErrorState, setError, showServerError } from "./error";

const normalizeBonus = (bonus) => ({
  id: bonus.bonus.id,
  type: bonus.bonus.type,
  amount: bonus.bonus.amount,
  available: bonus.available,
  stringId: bonus.bonus.string_id,
  depositAmount: bonus.deposit_amount,
  remainingWager: bonus.remaining_wager,
});

const initialState = {
  bonus: null,
  isModalShown: false,
  error: initialErrorState,
};

function bonusesReducer(state = initialState, action) {
  switch (action.type) {
    case BONUS_FETCH_SUCCESS: {
      const { bonus } = action.payload;

      return {
        ...state,
        bonus: bonus.bonus !== null ? normalizeBonus(bonus) : null,
        error: initialErrorState,
      };
    }

    case BONUS_FETCH_FAILURE: {
      return {
        ...state,
        error: setError(state.error, action.payload),
      };
    }

    case SHOW_BONUS_MODAL: {
      return {
        ...state,
        isModalShown: true,
      };
    }

    case HIDE_BONUS_MODAL: {
      return {
        ...state,
        isModalShown: false,
      };
    }

    case SHOW_BONUS_ERROR: {
      showServerError();
      return state;
    }

    default:
      return state;
  }
}

export default bonusesReducer;
